import React from "react";
import Navbar from "../../components/navbar/Navbar";
import ExpertList from "./components/ExpertList";
import Hero from "./components/Hero";

const ExpertsListHome = () => {
  return (
    <div className="min-h-screen bg-[#f8fafc] font-outfit relative pb-20">
      <Navbar />
      <Hero />

      {/* Container */}
      <div className="relative z-10 pt-24 max-w-7xl w-full mx-auto px-4 md:px-6">

        {/* Breadcrumbs */}
        <div className="text-white text-xs font-bold uppercase tracking-widest mb-6 opacity-80 flex items-center gap-2">
          <a href="/home" className="hover:text-blue-300 transition-colors">Home</a>
          <span>/</span>
          <span>Our Experts</span>
        </div>

        {/* White Canvas */}
        <div className="bg-white rounded-[2rem] shadow-xl border border-slate-100 overflow-hidden">
          <ExpertList />
        </div>

      </div>
    </div>
  );
};

export default ExpertsListHome;

